module.exports = __webpack_public_path__ + "img/36c7e7f.png";